import { pushEvent } from '../../client/data-layer';

/**
 * Tracks a change in the campaign sort order.
 */
export const trackSortOrderChange = order => {
  pushEvent('campaignSortOrderChange', { order });
};

/**
 * Tracks a click on any link to a campaign.
 */
export const trackCampaignLinkClick = (campaignId, linkType) => {
  pushEvent('campaignLinkClick', { campaignId, linkType });
};

/**
 * Tracks a click on a campaign item (that is, a product in the campaign).
 * The structure matches the Redux action CAMPAIGN_ITEM_CLICK.
 */
export const trackCampaignItemClick = item => {
  pushEvent('campaignItemClick', { item });
};
